import * as React from 'react';
import { Badge } from 'reactstrap';
import { mergeClasses } from '../constants';
import Icon from './Icons';
import './StatusRenderer.scss';

type Props = {
  className?: string;
  status?: string;
  label?: string;
  icon?: React.ReactNode;
};

export default class StatusRenderer extends React.PureComponent<Props> {
  render() {
    const { className, status, icon } = this.props;
    const label = this.props.label || status;
    let IconWidget, color;
    switch ((status || '').toLocaleUpperCase()) {
      case 'EDIT':
        IconWidget = Icon.Pencil;
        color = 'warning';
        break;
      case 'CREATE':
        IconWidget = Icon.Plus;
        color = 'warning';
        break;
      case 'OK':
      case 'ACTIVE':
        IconWidget = Icon.Check;
        color = 'success';
        break;
      case 'HEALTHY':
        IconWidget = Icon.HeartSolid;
        color = 'success';
        break;
      case 'PACKED':
        IconWidget = Icon.Box;
        color = 'info';
        break;
      case 'SHIPPED':
        IconWidget = Icon.Shipped;
        color = 'info';
        break;
      case 'STAGED':
        IconWidget = Icon.Hdd;
        color = 'warning';
        break;
      case 'WARNING':
      case 'PENDING':
        IconWidget = Icon.Hyphen;
        color = 'warning';
        break;
      case 'DOWN':
      case 'DEACTIVATING':
      case 'ERROR':
        IconWidget = Icon.X;
        color = 'danger';
        break;
      case 'UNHEALTHY':
        IconWidget = Icon.HeartOutline;
        color = 'danger';
        break;
      case 'N/A':
        IconWidget = Icon.Prohibited;
        color = 'unknown';
        break;
      default:
        IconWidget = Icon.Question;
        color = 'unknown';
    }

    const badgeIcon = icon || <IconWidget size={14} className="mr-2" />;

    return (
      <Badge
        color={color}
        className={mergeClasses(['status-badge', className])}
      >
        {badgeIcon}
        {label}
      </Badge>
    );
  }
}
